
import { h } from 'preact'

export const widows = (text) => {
	const words = text.trim().split(' ')
	if (words.length <= 1) return text
	const lastWord = words.pop()
	return `${words.join(' ')}\u00A0${lastWord}`
}

export const paragraphs = (string = '') => {
	const newlines = /\r\n|\r|\n/
	return string
		.trim()
		.split(newlines)
		.map(p => p.trim() 
			? <p>{widows(p.trim())}</p> 
			: null
		) 
}